import { Store, select } from '@ngrx/store';
import { Actions } from '@ngrx/effects';
import { values } from 'lodash-es';
import { map, delay } from 'rxjs/operators';
import { RootState } from '../../root-store/root.state';
import { selectSeButtonsTimeline, selectSeButtonsToolbarLeftSlider, selectSeButtonsToolbarRightSlider } from '../../root-store/root.selectors';

export abstract class SeButtonsToolbarBase {
    disableAll = false;

    isBackVisible: boolean;

    buttonsDataList$ = this.store.pipe(
        select('buttonsToolbar', 'buttons'),
        map(buttons => values(buttons)),
        delay(0)
    );

    leftSlider$ = this.store.pipe(select(selectSeButtonsToolbarLeftSlider));

    rightSlider$ = this.store.pipe(select(selectSeButtonsToolbarRightSlider));

    timelineOpen$ = this.store.pipe(select(selectSeButtonsTimeline));

    protected constructor(protected actions: Actions, protected store: Store<RootState>) { }
}
